<template>
  <div class="quiz-result">
    <div class="intro mb-3">
      Twoje motto: „Świat jest w zasięgu moich rąk”
    </div>

    <div class="cechy columns d-flex p-2">
      <div class="col-auto pt-3 images">
        <img :src="require('@/assets/images/segmentacja/thumb-wypedzeni-z-raju.jpg')"
             alt="group thumbnail"
             class="img-responsive"/>
      </div>
      <div class="pl-4 pl-sm-0 description-col">
        <img :src="require('@/assets/images/segmentacja/icon-wypedzani-z-raju.png')"
             alt="group thumbnail"
             class="img-responsive mb-2 icon"/>
        <p>
          Dom rodzinny jest dla Ciebie przystanią, a&nbsp;rodzice są autorytetem
          i&nbsp;wsparciem, wiesz, że zawsze możesz na nich liczyć.
        </p>
        <p>
          Nie spieszy Ci się do dorosłości – jesteś w&nbsp;takim momencie życia,
          kiedy możesz czerpać przyjemności i&nbsp;nie chcesz być jeszcze
          do&nbsp;końca odpowiedzialny za prozę życia.
        </p>
        <p>
          Swoje dorosłe życie chcesz zaplanować tak, aby móc się cieszyć każdą chwilą.<br/>
          Nie chcesz pędzić i&nbsp;wyznaczać sobie ciągle nowych celów.<br/>
          Potrzebujesz balansu pomiędzy pracą zawodową a&nbsp;życiem prywatnym.
        </p>
        <p>
          Czasami męczy Cię paradoks wyboru – jest wiele ścieżek i&nbsp;nie zawsze wiadomo,
          którą z&nbsp;nich należy wybrać.
        </p>
        <p>
          Nie potrafisz być bierny, kiedy dzieje się krzywda.
          Starasz się pomagać innym, bierzesz udział w&nbsp;różnych inicjatywach
          mających na celu wsparcie potrzebujących.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WypedzaniZRaju',
};
</script>

<style scoped>
.intro {
  color: #FFFFFF;
  background: var(--color-wypedzani-z-raju);
  font-size: 1.3em;
  font-weight: 700;
  padding: .6em .8em;
}
</style>
